/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface KnownTimeMapping
 */
export interface KnownTimeMapping {
    /**
     * 
     */
    shownTimestamp: Date;
    /**
     * 
     */
    trueTimestamp: Date;
}

/**
 * Check if a given object implements the KnownTimeMapping interface.
 */
export function instanceOfKnownTimeMapping(value: object): value is KnownTimeMapping {
    if ((!('shownTimestamp' in (value as Record<string, any>)) && !('shown_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['shownTimestamp'] === undefined && (value as Record<string, any>)['shown_timestamp'] === undefined)) return false;
    if ((!('trueTimestamp' in (value as Record<string, any>)) && !('true_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['trueTimestamp'] === undefined && (value as Record<string, any>)['true_timestamp'] === undefined)) return false;
    return true;
}

export function KnownTimeMappingFromJSON(json: any): KnownTimeMapping {
    return KnownTimeMappingFromJSONTyped(json, false);
}

export function KnownTimeMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): KnownTimeMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'shownTimestamp': (json['shown_timestamp'] == null ? json['shown_timestamp'] : parseDateTime(json['shown_timestamp'])),
        'trueTimestamp': (json['true_timestamp'] == null ? json['true_timestamp'] : parseDateTime(json['true_timestamp'])),
    };
}

export function KnownTimeMappingToJSON(json: any): KnownTimeMapping {
    return KnownTimeMappingToJSONTyped(json, false);
}

export function KnownTimeMappingToJSONTyped(value?: KnownTimeMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shown_timestamp': value['shownTimestamp'] == null ? value['shownTimestamp'] : serializeDateTime(value['shownTimestamp']),
        'true_timestamp': value['trueTimestamp'] == null ? value['trueTimestamp'] : serializeDateTime(value['trueTimestamp']),
    };
}

